import styled from '@emotion/styled';
import LiveClassPrime from 'aquilla/core/organisms/LiveClassPrime';
import TopTrendingCardPrime from 'aquilla/core/organisms/TopTrendingCardPrime';
import { Spacings } from '@styles/index';

export const PrimeTrendingCard = styled(TopTrendingCardPrime)`
  & > div[aria-hidden='true'] {
    margin-left: ${Spacings.SPACING_3B};
    font-style: unset;
    transform: skew(-15deg);
    font-weight: 1000;
  }
`;

export const BottomSpacer = styled.div`
  grid-column: 1 / -1;
  height: 10px;

  @media screen and (max-width: 768px) {
    height: 20px;
  }
`;

export const PrimeCardWrap = styled.div`
  width: 272px;
  aspect-ratio: 272 / 242;

  @media screen and (max-width: 768px) {
    width: 160px;
    aspect-ratio: 160 / 200;
  }
`;

export const PillsWrapper = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  margin-left: ${Spacings.SPACING_4B};
  align-items: center;
  gap: ${Spacings.SPACING_3B};

  padding: ${Spacings.SPACING_12B} 0;

  box-sizing: border-box;

  overflow-x: auto;
  overflow-y: hidden;

  flex-wrap: nowrap;

  scrollbar-width: none;

  background: url('/static/images/prime/prime-background-web.svg') center center /
    855px 131px no-repeat;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MobilePrimeBanner = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: sticky;
    top: ${Spacings.SPACING_12B};
    z-index: 3;
    width: 100vw;
    margin-left: -${Spacings.SPACING_4B};
    background-color: var(--color-i-prime-surface-dark);
    background-image: url('/static/images/prime/prime-background-mweb.svg');
    background-position: center -${Spacings.SPACING_12B};
    background-size: 100% auto;
    background-repeat: no-repeat;
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B}
      ${Spacings.SPACING_3B};
    box-sizing: border-box;
  }
`;

export const PrimeLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${Spacings.SPACING_4B};
`;

export const MobileSearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
  width: 100%;
  height: ${Spacings.SPACING_10B};
  padding: 0 ${Spacings.SPACING_3B};
  box-sizing: border-box;
  border-radius: ${Spacings.SPACING_2B};
  background: rgba(255, 255, 255, 0.08);
  margin-bottom: ${Spacings.SPACING_3B};
  cursor: pointer;
`;

export const SearchIcon = styled.svg`
  flex-shrink: 0;
`;

export const SearchPlaceholder = styled.span`
  font-family: 'Averta Std', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--color-white-55);
`;

export const StyledLiveClassPrime = styled(LiveClassPrime)`
  width: 100%;

  & > div {
    width: 100%;
  }

  /* DesktopOnly > DesktopCard */
  & > div:last-child > div {
    height: 280px;
    border-radius: ${Spacings.SPACING_4B};
    padding: ${Spacings.SPACING_4B};
    gap: ${Spacings.SPACING_8B};
    box-sizing: border-box;
  }

  /* DesktopOnly > DesktopCard > DesktopImage */
  & > div:last-child > div > img {
    height: 100%;
    width: auto;
    aspect-ratio: 1 / 1;
  }
`;

export const MobilePillsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

type PillProps = {
  $selected: boolean;
};

export const Pill = styled.button<PillProps>`
  border: 1px solid var(--color-i-pitch-black);

  border-radius: 58px;

  padding: 0 ${Spacings.SPACING_3B};

  height: ${Spacings.SPACING_8B};

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 2px;

  cursor: pointer;

  transition: all 0.2s ease;

  background: ${({ $selected }) =>
    $selected ? 'var(--color-i-white)' : '#FFFFFF1A'};

  color: ${({ $selected }) =>
    $selected ? 'var(--color-i-prime-text-dark)' : '#FFFFFF80'};

  font-family: 'Averta Std', sans-serif;

  font-weight: ${({ $selected }) => ($selected ? 600 : 400)};

  font-size: 14px;

  line-height: 18px;

  white-space: nowrap;
`;
